export function busy() {
  let a = 0;
  for (let i = 0; i < 1_00; i++) {
    a++;
  }
}
